export const getBadge = (badgeId) => ({ badges }) =>
  badges.badgesList.find(({ id }) => id === badgeId);
